import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { CustomsData } from './CustomsData';

// Số liệu hải quan (O-02). Vào từ Dịch vụ, không thêm mục menu.
const customsdata: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/customs-data', component: CustomsData })],
};
export default customsdata;
